import { cn } from '@dreamstack/util/src/cn'
import { Disclosure } from '@headlessui/react'
import type { FunctionComponent } from 'react'
import {
  expandableTitle,
  StyledGridWithGaps,
  StyledHeadingH2,
  StyledMinus,
  StyledPlus,
} from './AccordionStyledComponents'

export const DisclosureButton: FunctionComponent<
  React.PropsWithChildren<{
    open: boolean
    title: string
    titleWhenExpanded?: string
    clickHandler?: (index: number, action: boolean) => void
    index?: number
    className?: string
    useAqua?: boolean
    smallSize?: boolean
  }>
> = ({
  open,
  title,
  titleWhenExpanded,
  clickHandler,
  index,
  useAqua,
  smallSize,
  className,
}) => {
  return (
    <>
      <Disclosure.Button
        className={cn(
          'text-left w-full text-accentroGray-full focus:outline-none',
          className
        )}
      >
        <StyledGridWithGaps useAqua={useAqua}>
          <div
            role="button"
            onClick={() =>
              clickHandler && index ? clickHandler(index, open) : null
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                clickHandler && index ? clickHandler(index, open) : null
              }
            }}
            tabIndex={0}
            className="contents"
          >
            {open ? (
              <StyledMinus $smallSize={smallSize} />
            ) : (
              <StyledPlus $smallSize={smallSize} />
            )}
            <StyledHeadingH2 smallSize={smallSize}>
              {expandableTitle(title, titleWhenExpanded, open)}
            </StyledHeadingH2>
          </div>
        </StyledGridWithGaps>
      </Disclosure.Button>
    </>
  )
}
